import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'ark-ui-vote',
  templateUrl: './ui-vote.component.html',
  styleUrls: ['./ui-vote.component.scss'],
})
export class UiVoteComponent implements OnInit {
  @Input() voted = false;
  @Input() upvoteCount?: number;

  @Output() upvoted = new EventEmitter<void>();
  @Output() downvoted = new EventEmitter<void>();
  constructor() {}

  ngOnInit() {}
}
